import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { accountModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppUrlService } from '@shared/common/nav/app-url.service';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { AccountServiceProxy, PasswordComplexitySetting, ProfileServiceProxy, ResetPasswordOutput, ResolveTenantIdInput } from '@shared/service-proxies/service-proxies';
import { LoginService } from '../login/login.service';
import { ResetPasswordModel } from './reset-password.model';
import { finalize } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AbpModule } from 'abp-ng2-module';
import { UtilsModule } from '@shared/utils/utils.module';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    animations: [accountModuleAnimation()],
    standalone: true,
    imports: [FormsModule, NgbModule, UtilsModule, AbpModule, CommonModule, RouterModule]
})
export class ResetPasswordComponent extends AppComponentBase implements OnInit {

    
    passwordComplexitySetting: PasswordComplexitySetting = new PasswordComplexitySetting();
    saving = false;
    @Input() model: ResetPasswordModel = new ResetPasswordModel();
    @Input() isPopup: boolean = false;
    @Input() isWebFacing: boolean = false;
    @Output() stepUpdate: EventEmitter<number> = new EventEmitter<number>()

    constructor(
        injector: Injector,
        private _accountService: AccountServiceProxy,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _loginService: LoginService,
        private _appSessionService: AppSessionService,
        private _profileService: ProfileServiceProxy
    ) {
        super(injector);
    }

    ngOnInit(): void {
        // Support both route-based and direct input usage
        // If model.c, userId, or resetCode are already set (via @Input), use them; otherwise, get from route
        if (!this.model.c && !this.model.userId && !this.model.resetCode) {
            // Populate from route if not set via @Input
            this.model.c = this._activatedRoute.snapshot.queryParams['c'];
            this.model.userId = this._activatedRoute.snapshot.queryParams['userId'];
            this.model.resetCode = this._activatedRoute.snapshot.queryParams['resetCode'];
        }

        if (this.model.c) {
            this._accountService.resolveTenantId(new ResolveTenantIdInput({ c: this.model.c })).subscribe((tenantId) => {
            this._appSessionService.changeTenantIfNeeded(tenantId);

            this._profileService.getPasswordComplexitySetting().subscribe(result => {
                this.passwordComplexitySetting = result.setting;
            });
            });
        } else if (this.model.userId && this.model.resetCode) {
            this._appSessionService.changeTenantIfNeeded(1);
            this._profileService.getPasswordComplexitySetting().subscribe(result => {
            this.passwordComplexitySetting = result.setting;
            });
        }
    }

    save(): void {
        this.saving = true;
        this._accountService.resetPassword(this.model)
            .pipe(finalize(() => { this.saving = false; }))
            .subscribe((result: ResetPasswordOutput) => {
                // Autheticate
                this.saving = true;
                this._loginService.authenticateModel.userNameOrEmailAddress = result.userName;
                this._loginService.authenticateModel.password = btoa(this.model.password);
                this._loginService.authenticate(() => {
                    this.saving = false;
                }, undefined, false, this.isPopup);
            });
    }

    parseTenantId(tenantIdAsStr?: string): number {
        let tenantId = !tenantIdAsStr ? undefined : parseInt(tenantIdAsStr);
        return tenantId;
    }

    returnToLogin(): void {
        if (this.isPopup) {
            if (this.stepUpdate)
                this.stepUpdate.emit(1); // Emit an event to update the step in the parent component
        }
        else
            this._router.navigate(['/login']);
    }
}
